import React, {Component} from 'react';
import {Link} from "react-router";
import ThemableSvgIcon from "./theme/ThemableSvgIcon";
import {classNames} from "../utils/miscUtils";
import {imagePath} from "../utils/imageUtils";

function DashboardTile(props) {
    const Component = props.disabled ? DisabledDiv : props.externalLinkText ? ExternalLink :  Link;
    const titleClass = props.disabled ? "text-grey-light" : "text-primary-dark";
    const descriptionClass = props.disabled ? "text-grey-light" : "";
    return (
        <Component
            className="bg-white border text-center p-4 shadow"
            to={props.linkTo}
            disabled={props.disabled}
        >
            <div>
                <div className="relative inline-block">
                    {props.status &&
                    <div className="absolute mt-2 right-0">
                        {props.status === "COMPLETE" ?
                            <ThemableSvgIcon name="tick-circle" className={classNames("w-6 h-6", props.disabled ? "text-grey-light" : "text-success")}/> :
                            <ThemableSvgIcon name="info-circle" className={classNames("w-6 h-6", props.disabled ? "text-grey-light" : "text-red")}/>
                        }
                    </div>
                    }
                    <ThemableSvgIcon name={props.icon} className={`w-18 h-18 mx-2 inline-block ${props.disabled ? "text-grey-light" : "text-primary-dark"}`}/>
                </div>

            </div>
            <div className={`mt-4 uppercase text-lg font-bold ${titleClass}`}>
                {props.title}
            </div>

            {props.description &&
            <div className={`mt-1 min-h-10 ${descriptionClass}`}>
                {props.description}
            </div>
            }

            {props.externalLinkText &&
            <div className="mt-1 min-h-10 leading-middle text-primary">
                <span className="underline">
                    {props.externalLinkText}
                </span> <img className="inline-block align-text-top" src={imagePath("external_link_icon.png")} alt=""/>
            </div>
            }

        </Component>

    );
}

function DisabledDiv(props) {
    return (
        <div {...props} className={`${props.className} text-grey-light cursor-not-allowed`}></div>
    )
}

function ExternalLink(props) {
    return <a {...props} href={props.to} target="_blank" rel="noopener noreferrer"></a>
}

export default DashboardTile;